module.exports = __webpack_public_path__ + "img/cura-ao.346ff140.svg";